import request from '../untils/request';

export const operationInviteApi = params => {
  return request({
    url: '/operation/invite-code/index',
    authCode: 'INVITE-CODE-INDEX',
    params,
  });
};
